import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="aspect-[3/4] rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20young%20European%20man%20in%20casual%20designer%20streetwear%20standing%20against%20warm%20terracotta%20colored%20wall%2C%20portrait%20photography%20with%20strong%20natural%20side%20lighting%20creating%20dramatic%20shadows%2C%20genuine%20relaxed%20expression%2C%20modern%20editorial%20style%2C%20rich%20warm%20color%20palette%2C%20high-end%20fashion%20portrait%20aesthetic&width=600&height=800&seq=testimonial-v2&orientation=portrait"
                alt="Kakobuy Spreadsheet user review"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <p className="text-xs text-foreground-400 uppercase tracking-widest mb-3">
              ({t('testimonial.label')})
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-8">
              {t('testimonial.title1')}{' '}
              <span className="text-foreground-300">{t('testimonial.title2')}</span>
            </h2>
            <blockquote className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6 italic border-l-4 border-accent-400 pl-6">
              "{t('testimonial.quote')}"
            </blockquote>
            <p className="text-foreground-900 font-semibold text-sm">
              – {t('testimonial.author')}
            </p>

            <div className="flex items-center gap-3 mt-8">
              <button className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-400 hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}